import { NavBar, NavItem, NavLink } from "./Navigation.styled";

function Navigation() {
  return (
    <NavBar>
      <NavItem>
        <NavLink to="/">מומלצים</NavLink>
      </NavItem>
      <NavItem>
        <NavLink to="/">כל המשחקים</NavLink>
      </NavItem>
      <NavItem>
        <NavLink to="/">משחקי מילים</NavLink>
      </NavItem>
      <NavItem>
        <NavLink to="/">חידונים</NavLink>
      </NavItem>
    </NavBar>
  );
}

export default Navigation;
